import React, { forwardRef } from 'react'
import styled from 'styled-components'
import _Button from 'LuxKit/Button/BaseButton'
import TextButton from 'LuxKit/Button/TextButton'
import SolidHeartIcon from 'LuxKit/Icons/solid/SolidHeartIcon'
import DropdownChevron from 'LuxKit/Dropdown/DropdownChevron'

const Container = styled.div`
  position: relative;
`

interface Props {
  onClick: (e: React.MouseEvent<HTMLButtonElement>, overRideVal?: boolean) => void
  isOpen?: boolean
}

const TripPlannerFloatingToggleButton = forwardRef<HTMLButtonElement, Props>((props, ref) => {
  const {
    onClick,
    isOpen = false,
  } = props

  return (
    <Container>
      <TextButton
        kind="secondary"
        variant="dark"
        size="large"
        shape="round"
        startIcon={<SolidHeartIcon colour="favourite" />}
        ref={ref}
        endIcon={<DropdownChevron direction={isOpen ? 'down' : 'up'} />}
        onClick={onClick}
      >
        Saved
      </TextButton>
    </Container>
  )
})

export default TripPlannerFloatingToggleButton
